import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(61, 49, 70, 0.36);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-family: 'Inter', sans-serif;
`;

export const Modal = styled.div`
  background: rgba(255, 248, 242, 0.92);
  border: 1px solid rgba(118, 101, 123, 0.12);
  border-radius: 28px;
  width: 420px;
  max-width: calc(100vw - 40px);
  box-shadow: 0 20px 48px rgba(90, 74, 94, 0.16);
  position: relative;
  backdrop-filter: blur(12px);
  font-family: 'Inter', sans-serif;
`;

export const ModalInner = styled.div`
  padding: 1.5rem 1.5rem 1.75rem;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  color: #3d3146;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  line-height: 1.25;
`;

export const Close = styled.button`
  background: transparent;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: #5d5561;
  cursor: pointer;
  padding: 0.15rem 0.35rem;
  transition: color 0.15s ease;

  &:hover {
    color: #3d3146;
  }
`;

export const ProfileCard = styled.div`
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(118, 101, 123, 0.12);
  border-radius: 18px;
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 0.5rem 0 1rem;
  box-shadow: 0 10px 26px rgba(90, 74, 94, 0.08);
`;

export const Avatar = styled.div`
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background-color: rgba(143, 165, 149, 0.18);
  background-size: cover;
  background-position: center;
  flex: 0 0 68px;
  border: 1px solid rgba(118, 101, 123, 0.12);
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const Name = styled.div`
  font-weight: 700;
  font-size: 1.1rem;
  color: #3d3146;
`;

export const Meta = styled.div`
  font-size: 0.92rem;
  color: #675d69;
  line-height: 1.4;
`;

export const BluePill = styled.span`
  background: rgba(143, 165, 149, 0.22);
  color: #4f6154;
  border-radius: 999px;
  padding: 6px 12px;
  font-weight: 700;
  font-size: 0.82rem;
  display: inline-block;
`;

export const QRBox = styled.div`
  margin: 0.75rem auto 1rem;
  width: 100%;
  max-width: 260px;
  min-height: 220px;
  padding: 1.25rem 1rem;
  box-sizing: border-box;
  background: rgba(143, 165, 149, 0.14);
  border: 1px solid rgba(118, 101, 123, 0.12);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #3d3146;
  gap: 8px;
`;

export const QRHint = styled.div`
  color: #5f7565;
  font-size: 0.9rem;
  font-weight: 600;
`;

export const ErrorText = styled.div`
  color: #a14d4d;
  font-size: 0.9rem;
  text-align: center;
  line-height: 1.5;
`;

export const MetaText = styled.div`
  color: #675d69;
  font-size: 0.9rem;
  text-align: center;
`;

export const Steps = styled.div`
  margin: 0.75rem 0 0.25rem;
  padding: 1rem;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(118, 101, 123, 0.1);
`;

export const StepTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #3d3146;
  margin: 0 0 0.75rem 0;
  font-size: 1.05rem;
`;

export const StepList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #5d5561;
`;

export const StepItem = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #5d5561;
  font-size: 0.95rem;
  line-height: 1.4;
`;

export const Primary = styled.button`
  display: block;
  width: 100%;
  background: linear-gradient(135deg, #8d6f92 0%, #73907a 100%);
  color: #fffaf4;
  border: none;
  border-radius: 16px;
  padding: 0.95rem 1.5rem;
  font-weight: 700;
  font-size: 1.05rem;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  box-shadow: 0 16px 34px rgba(111, 86, 116, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  margin-top: 0.5rem;

  &:visited {
    color: #fffaf4;
  }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 18px 36px rgba(111, 86, 116, 0.22);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

export const Secondary = styled.button`
  display: block;
  width: 100%;
  background: rgba(255, 248, 242, 0.8);
  color: #5d5561;
  border: 1px solid rgba(118, 101, 123, 0.16);
  border-radius: 14px;
  padding: 0.85rem 1.35rem;
  font-weight: 600;
  font-size: 0.98rem;
  cursor: pointer;
  text-align: center;
  margin-top: 0.5rem;
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    border-color: rgba(113, 144, 122, 0.32);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;
